/**
 * Ajax addtocart Btn
 * ======================================
 * - jquery needed
 * - handled with ajax/index.php
 */
import $ from "jquery";

const $cart_count = $("#woo-cart_count");
const $cart_total = $("#woo-cart_total");
const $emptycart = $("#woocommerce-emptycart");
var request;

$("body").on("input", ".js-updatecartquantity", function(e) {
	const $field = $(this);
	const $row = $field.closest(".basket-item");
	const $row_price = $row.find(".woo-price .amount");
	const wckey = $row.attr("data-wckey");
	const quantity = $field.val();
	const product_id = $row.attr("data-product");

	var data = new FormData();
	data.append("action", "updatecartquantity");
	data.append("quantity", quantity);
	data.append("product", product_id);
	data.append("wckey", wckey);

	// ajax js
	$field.addClass("disabled");

	clearTimeout(request);

	request = setTimeout(function() {
		const xhr = new XMLHttpRequest();
		xhr.open("POST", ajaxUrl + "/index.php", true);
		xhr.send(data);

		xhr.onreadystatechange = function() {
			if (xhr.readyState === 4) {
				// success
				if (xhr.status === 200) {
					$field.removeClass("disabled");
					const response = JSON.parse(xhr.response);

					$row_price.replaceWith(response.item_price);
					$cart_count.html(response.cart_count);
					$cart_total.html(response.cart_total);

					var event = new Event("ajax-popcart");
					window.dispatchEvent(event);

					if (response.cart_count == 0) {
						$emptycart.removeClass("is-hidden");
						var removeTimeout = 300;
					} else {
						$emptycart.addClass("is-hidden");
						var removeTimeout = 0;
					}

					if (quantity == 0) {
						setTimeout(function() {
							$row.remove();
						}, removeTimeout);
					}
				}
				// error
				else {
					console.log("ajaxForm error!", xhr);
				}
			}
		};
	}, 500);

	e.preventDefault();
});
